import moment from 'moment-jalaali';
import locales from 'locales';
import { lazy } from 'react';

const setWidth = (elm, val) => {
  if (elm) {
    const bodyWidth = document.querySelector('body').offsetWidth;
    // eslint-disable-next-line no-param-reassign
    elm.style.width = `${bodyWidth - val}px`;
  }
};

const adjustWidthLogic = (elm, value = 0) => {
  if (elm) {
    const resizeStack = window.onresize;
    window.onresize = () => {
      if (resizeStack != null) {
        resizeStack();
      }
      setWidth(elm, value);
    };
    setWidth(elm, value);
  }
};

const getExtension = filename => {
  const parts = filename.split('.');
  return parts[parts.length - 1];
};

export const randomizeId = () => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < 16; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const tools = {
  isJson: item => {
    let updatedItem = typeof item !== 'string' ? JSON.stringify(item) : item;

    try {
      updatedItem = JSON.parse(updatedItem);
    } catch (e) {
      return false;
    }

    if (typeof updatedItem === 'object' && updatedItem !== null) {
      return true;
    }

    return false;
  },

  toPersianDigits: str => {
    const id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return str.replace(/[0-9]/g, w => id[+w]);
  },

  toEnglishDigits: value => {
    if (value === null || value === undefined) return '';
    const toEnDict = {
      '۰': 0,
      '۱': 1,
      '۲': 2,
      '۳': 3,
      '۴': 4,
      '۵': 5,
      '۶': 6,
      '۷': 7,
      '۸': 8,
      '۹': 9,
    };
    const letters = value.toString().split('');
    const arr = letters.map(item => (item in toEnDict ? toEnDict[item] : item));
    return arr.join('');
  },

  normalizeNumber: value => {
    if (value === null || value === undefined) return '';
    const toEnDict = {
      '۰': 0,
      '۱': 1,
      '۲': 2,
      '۳': 3,
      '۴': 4,
      '۵': 5,
      '۶': 6,
      '۷': 7,
      '۸': 8,
      '۹': 9,
    };
    const letters = value.toString().split('');
    let result = letters
      .map(item => (item in toEnDict ? toEnDict[item] : item))
      .join('');
    result = result.replace(/[^\d]/g, '');
    return result;
  },

  dateObjectToString: date =>
    date ? `${date?.year}/${date?.month}/${date?.day}` : '',

  dateStringToObject: date => {
    if (date) {
      const [year, month, day] = date
        .split('/')
        .map(item => parseInt(item, 10));
      return { year, month, day };
    }
    return null;
  },

  toJalaaliDate: (date, format, loadPersian) => {
    if (loadPersian) moment.loadPersian(true);
    return date
      ? Number(date)
        ? moment(date, 'X').format(format || 'jYYYY/jMM/jDD')
        : moment(date, 'YYYY/MM/DD').format(format || 'jYYYY/jMM/jDD')
      : null;
  },

  toGregorianDate: (date, format) =>
    moment(date, format || 'jYYYY/jMM/jDD').format('YYYY-MM-DD'),

  lastUpdate: date =>
    date
      ? tools.toJalaaliDate(date, `jD jMMMM jYYYY ${locales.hour} HH:mm`, true)
      : '',

  random: (min, max) => {
    const minValue = Math.ceil(min);
    const maxValue = Math.floor(max);
    return Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
  },

  updateList: (list, item) => {
    const res = list;
    const index = res.findIndex(x => x === item);
    if (index === -1) {
      res.push(item);
    } else {
      res.splice(index, 1);
    }
    return res;
  },

  adjustWidth: (elm, value = 0) => {
    if (elm) {
      if (elm.current) {
        adjustWidthLogic(elm.current, value);
      } else {
        adjustWidthLogic(elm, value);
      }
    }
  },

  millisecondsToDays: timestamp => {
    const ts = timestamp * 1000;
    return Math.ceil(ts / (1000 * 60 * 60 * 24));
  },

  getWeekDay: timestamp => {
    const dt = new Date(timestamp * 1000);
    const dayName = locales.weekDayNames[dt.getDay()];
    return dayName;
  },

  timeBuilder: timestamp => {
    const dt = new Date(timestamp * 1000);
    const dtFormat = moment(dt).format('HH:mm');
    return dtFormat;
  },

  dateAgo: days => new Date(new Date().getTime() - days * 24 * 60 * 60 * 1000),

  validateEmail: str => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(str).toLowerCase());
  },

  validateNationalCode: str => {
    const len = str.length;
    if (len < 8 || parseInt(str, 10) === 0) return false;
    const code = `0000${str}`.substr(len + 4 - 10);
    if (parseInt(code.substr(3, 6), 10) === 0) return false;
    const c = parseInt(code.substr(9, 1), 10);
    let s = 0;
    for (let i = 0; i < 9; i += 1)
      s += parseInt(code.substr(i, 1), 10) * (10 - i);
    s %= 11;
    return (s < 2 && c === s) || (s >= 2 && c === 11 - s);
  },

  scrollToBottom: () => {
    const el = document.querySelector('body');
    el.scrollIntoView({ behavior: 'smooth' });
  },

  isImage: filename => {
    const ext = getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'png':
        return true;
      default:
        return false;
    }
  },

  ellipsis: (str, len) => {
    const strString = str.toString();
    return strString.length > len
      ? `${strString.substr(0, len)}...`
      : strString;
  },

  difference: (date1, date2) => {
    const firstDate = new Date(date1);
    const secondDate = new Date(date2);
    const differenceInTime = secondDate.getTime() - firstDate.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
    return differenceInDays > 0 ? differenceInDays : 0;
  },

  parseJwt: token => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join(''),
    );

    return JSON.parse(jsonPayload);
  },

  isExternalURL: url => {
    const pattern = RegExp(`^((f|ht)tps?:)?//(?!${window.location.host})`);
    return pattern.test(url);
  },

  // eslint-disable-next-line no-restricted-globals
  isNumber: val => !isNaN(val),

  isEmpty: value =>
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0),
  // a function to retry loading a chunk to avoid chunk load error for out of date code
  lazyRetry: componentImport =>
    new Promise((resolve, reject) => {
      // check if the window has already been refreshed
      const hasRefreshed = JSON.parse(
        window.sessionStorage.getItem('retry-lazy-refreshed') || 'false',
      );
      // try to import the component
      componentImport()
        .then(component => {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'false'); // success so reset the refresh
          resolve(component);
        })
        // eslint-disable-next-line consistent-return
        .catch(error => {
          if (!hasRefreshed) {
            // not been refreshed yet
            window.sessionStorage.setItem('retry-lazy-refreshed', 'true'); // we are now going to refresh
            console.info(`Reload 1, Error : ${error}`);
            // return window.location.reload(); // refresh the page
          }
          reject(error); // Default error behaviour as already tried refresh
        });
    }),
  lazyWithRetry: componentImport =>
    lazy(() => tools.lazyRetry(componentImport)),
};

export default tools;
